<div class="col-md-12">
    <ul class="social-icons">
        <li>
            <a href="https://www.youtube.com/@polywinegypt" target="_blank">
                <!-- <i-tabler name="brand-youtube" class="icon-25 d-flex icon"></i-tabler> -->
                <img src="../../../../assets/images/icon-youtube.png" />
            </a>
        </li>
        <li>
            <a href="https://www.instagram.com/polywin.eg/?utm_media=copy_link" target="_blank">
                <!-- <i-tabler name="brand-instagram" class="icon-25 d-flex icon"></i-tabler> -->
                <img src="../../../../assets/images/icon-instagram.png" />
            </a>
        </li>
        <li>
            <a href="https://www.facebook.com/polywin.eg/?utm_media=copy_link" target="_blank">
                <!-- <i-tabler name="brand-facebook" class="icon-25 d-flex icon"></i-tabler> -->
                <img src="../../../../assets/images/icon-facebook.png" />
            </a>
        </li>
        <li>
            <a href="#" target="_blank">
                <i-tabler name="brand-dribbble" class="icon-25 d-flex icon"></i-tabler>
                <!-- <img src="../../../../assets/images/icon-website.png" /> -->
            </a>
        </li>
    </ul>
</div>